import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  sortCaret,
  headerSortingClasses,
} from "../../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  showSuccessDialog,
  showErrorDialog,
  StatusFormatter,
  useForceUpdate,
  sizePerPageList,
  showDialog,
  showConfirmDialog,
  formatCurrency,
} from "../../../utility";
import {
  resetData,
  selectRtv,
  createRtv,
  selectReasonParam,
  fetchReasonParam,
  uploadFile,
  editRtv,
  selectLoading,
  fetchCustomer,
  selectDataCustomer,
  selectPageNo,
  selectPageSize,
  selectDataMaterialOld,
  fetchMaterialOld,
} from "./withrtvSlice";
import DeleteIcon from "@material-ui/icons/Delete";
import ImageIcon from "@material-ui/icons/Image";
import Select from "react-select";
import moment from "moment";
import InputNumber from "../without-rtv/InputNumber";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import LoadingFetchData from "../../../utility/LoadingFetchData";
import {
  selectDataBatch,
  fetchBatch,
} from "../without-rtv/reference/withoutRtvSlice";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { v4 as uuidv4 } from "uuid";

export const WithRtvDetailDraft = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const forceUpdate = useForceUpdate();
  const reasonParam = useSelector(selectReasonParam);
  const data = useSelector(selectRtv);
  const loading = useSelector(selectLoading);
  const dataCustomer = useSelector(selectDataCustomer);
  const dataMaterial = useSelector(selectDataMaterialOld);
  const dataBatch = useSelector(selectDataBatch);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);

  // Add status field to prevent object is not extensible error
  const getValueDefaultUom = (value, options) => {
    return options.filter((val) => value === val.uom);
  };

  console.log(data, "data");

  const initData = data.map((item, index) => ({
    ...item,
    no: index + 1,
    returnUom: item.uom,
    customerCodeOld: item.customerCode,
    customerNameOld: item.customerName,
    plantCodeOld: item.plantCode,
    plantNameOld: item.plantName,
    defaulfUom: getValueDefaultUom(item.uom, item.altUom),
    materialCodeOld: item.materialCode,
    materialDescription: item.materialDescription,
    batchOld: item.batch,
    netPriceOld: item.netPrice,
    addLine: "N",
    isClick: "Y",
    lineOld: item.line,
  }));

  const [tableData, setTableData] = useState(initData);
  const [tableDataOld, setTableDataOld] = useState(initData);
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [rowIndexTable, setRowIndexTable] = useState(null);
  const [pelapor, setPelapor] = useState(null);
  const [cekQty, setCekQty] = useState(false);
  const [changes, setChanges] = useState("N");

  const [btnDisabled, setBtnDisabled] = useState(false);

  console.log(tableData, "tabledata");

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());

    // Fetch data on first load
    dispatch(
      fetchReasonParam({
        paramGroupId: "REASON",
        pageNo: 1,
        pageSize: 20,
      })
    );
    setReason(data[0].reasonCode);
  }, [dispatch]);

  useEffect(() => {
    tableData.forEach((item) => {
      item.tempAvailableQty = item.availableQty;
      item.qty = item.qty;
      item.uuid = uuidv4();
    });
    setTableData(tableData);
  }, [tableData]);

  // const optionsTablePage = {
  //   showTotal: true,
  //   totalSize: tableData.length,
  //   sizePerPageList: sizePerPageList,
  // };
  // Return if data null
  if (!tableData.length > 0) {
    history.push("/new-return/with-rtv");
  }

  const handleReasonChange = (value) => {
    setReason(value.value);
    forceUpdate();
  };

  const reasonOptions = reasonParam.map((e) => {
    return {
      value: e.paramCode,
      label: e.paramValue,
    };
  });

  const getValueReason = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  // UOM Render
  const getValueUom = (value, options) => {
    return options.filter((val) => value === val.label);
  };

  const handleUomValueChange = async (
    e,
    row,
    rowIndex,
    options,
    formatExtraData
  ) => {
    const selected = options.filter((val) => e.value === val.label);
    const uom = selected[0];
    const baseUom = formatExtraData[rowIndex].defaulfUom[0].uom;
    const fromNumerator = formatExtraData[rowIndex].defaulfUom[0].numerator;
    const fromDenumerator = formatExtraData[rowIndex].defaulfUom[0].denumerator;
    const selectedUom = uom.value;
    const toNumerator = uom.numerator;
    const toDenumerator = uom.denumerator;

    formatExtraData[rowIndex].returnUom = e.value;

    if (selectedUom === baseUom) {
      formatExtraData[rowIndex].qty = formatExtraData[rowIndex].availableQty;
      formatExtraData[rowIndex].tempAvailableQty =
        formatExtraData[rowIndex].availableQty;
    } else if (fromNumerator >= fromDenumerator) {
      if (fromNumerator < toNumerator) {
        console.log("xx");
        formatExtraData[rowIndex].tempAvailableQty =
          formatExtraData[rowIndex].availableQty *
          (((fromNumerator * fromDenumerator) / toNumerator) * toDenumerator);
        formatExtraData[rowIndex].qty =
          formatExtraData[rowIndex].availableQty *
          (((fromNumerator * fromDenumerator) / toNumerator) * toDenumerator);
      } else {
        console.log("yy");
        formatExtraData[rowIndex].tempAvailableQty =
          formatExtraData[rowIndex].availableQty *
          (fromNumerator * fromDenumerator * toNumerator * toDenumerator);
        formatExtraData[rowIndex].qty =
          formatExtraData[rowIndex].availableQty *
          (fromNumerator * fromDenumerator * toNumerator * toDenumerator);
      }
    } else {
      if (fromNumerator < toNumerator) {
        console.log("zz");
        formatExtraData[rowIndex].tempAvailableQty =
          formatExtraData[rowIndex].availableQty *
          ((fromNumerator / fromDenumerator / toNumerator) * toDenumerator);
        formatExtraData[rowIndex].qty =
          formatExtraData[rowIndex].availableQty *
          ((fromNumerator / fromDenumerator / toNumerator) * toDenumerator);
      } else {
        console.log("ss");
        formatExtraData[rowIndex].tempAvailableQty =
          formatExtraData[rowIndex].availableQty *
          ((fromNumerator / fromDenumerator) * toNumerator * toDenumerator);
        formatExtraData[rowIndex].qty =
          formatExtraData[rowIndex].availableQty *
          ((fromNumerator / fromDenumerator) * toNumerator * toDenumerator);
      }
    }
    setTableData(formatExtraData);
    forceUpdate();
  };

  const renderUom = (cell, row, rowIndex, formatExtraData) => {
    const alt_uom = row.altUom;
    let cell_uom = cell;

    const options_this = [
      { value: "", label: "", numerator: "", denumerator: "" },
    ];

    alt_uom.map((value, index) => {
      options_this.push({
        value: value.uom,
        label: value.uom,
        numerator: value.numerator,
        denumerator: value.denumerator,
      });
    });

    return (
      <Select
        isSearchable={false}
        className="uom-select"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        key={`uom-${rowIndex}`}
        options={options_this}
        onChange={(e) =>
          handleUomValueChange(e, row, rowIndex, options_this, formatExtraData)
        }
        value={getValueUom(cell_uom, options_this)}
      />
    );
  };

  const uploadFormatter = (cell, row, rowIndex, formatExtraData) => {
    let render = (
      <div>
        <input
          type="file"
          onChange={(e) =>
            handleUpload(e, rowIndex, row, cell, formatExtraData)
          }
          style={{ color: "transparent", width: "91px" }}
          accept="image/png, image/jpeg, image/jpg"
        />
      </div>
    );

    if (row.attachmentId) {
      render = (
        <div className="filename-container">
          <div className="div-filename">{row.filename}</div>
          <a
            href={`${process.env.REACT_APP_API_URL}/return/attachment/${row.attachmentId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageIcon style={{ color: "#648DAE", marginRight: "5px" }} />
          </a>
          <DeleteIcon
            onClick={(e) => handleDeleteFile(e, rowIndex, formatExtraData)}
          />
        </div>
      );
    }

    // if (formatExtraData.reason === "132") {
    //   render = "Cannot Upload";
    // }

    return render;
  };

  const handleUpload = async (e, rowIndex, row, cell, formatExtraData) => {
    const file = e.target.files[0];
    const params = {
      file: file,
    };
    try {
      const response = await dispatch(uploadFile(params));
      if (response.payload.status === 200) {
        // const action = await showSuccessDialog(response.payload.data);

        const temp = tableData;
        temp[rowIndex].attachmentId = response.payload.data;
        temp[rowIndex].filename = file.name;
        setTableData(temp);
        forceUpdate();
      }
    } catch (error) {
      console.log(error);
      showErrorDialog("Something went wrong!");
    }
  };

  const handleDeleteFile = async (e, rowIndex) => {
    const temp = tableData;
    temp[rowIndex].attachmentId = null;
    temp[rowIndex].filename = null;
    forceUpdate();
  };

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    console.log(e, "e");
    console.log(row, "row");
    console.log(formatExtraData, "formatExtraData");
    if (parseFloat(row.qty) > parseFloat(row.availableQty)) {
      row.qty = row.availableQty;
      forceUpdate();
      return;
    } else if (row.qty < 0) {
      row.qty = 0;
      forceUpdate();
      return;
    }
  };

  const inputQtyFormmater = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        className="input-qty-return"
        step="any"
        value={parseFloat(row.qty)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };
  // function Remark
  const handleRemarkRowChange = (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].remarkRow = e.target.value;
    setTableData(formatExtraData);
  };

  const remarkFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <Form.Control
          className={`remark-brqa`}
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: "80px" }}
          onChange={(e) =>
            handleRemarkRowChange(e, row, rowIndex, formatExtraData)
          }
          maxLength={255}
        />
      </div>
    );
  };

  const handleDraft = () => {
    setBtnDisabled(true);

    // Setup Request Body Params
    tableData.map((value) => {
      if (reason === "132") {
        value.sloc = "B41";
      } else if (reason === "135") {
        value.sloc = "B42";
      }
      if (value.qty) {
      } else {
        value.qty = value.availableQty;
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });
    const items = tableData.map((e) => {
      return {
        attachmentId: e.attachmentId,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        crprgp: e.crprgp,
        expiredDate: e.expiredDate,
        materialCode: e.materialCode,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        nra: e.nra,
        availableQty: e.availableQty,
        qty: e.qty,
        returnUom: e.returnUom,
        sloc: e.sloc,
        uom: e.uom,
        remark: e.remarkRow,
        rayonType: e.rayonType,
        line: e.line,
        returnDetailId: e.returnDetailId,
        division: e.division,
      };
    });
    const id = tableData[0].returnId;

    const params = {
      invoiceNo: tableData[0].invoiceNo,
      taxInvoiceNo: tableData[0].taxInvoiceNo,
      customerCode: tableData[0].customerCode.toString(),
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      reasonCode: reason,
      transactionDate: moment(tableData[0].transactionDate).format(
        "YYYY-MM-DD"
      ),
      plantCode: tableData[0].plantCode,
      po: tableData[0].po,
      dataSource: tableData[0].dataSource,
      crprgp: tableData[0].crprgp,
      returnType: "MTKA",
      remark: remark,
      draft: true,
      rtvNo: tableData[0].rtvNo,
      rtvDate: tableData[0].rtvDate,
      rtvReceivingDate: tableData[0].rtvReceivingDate,
      remarksRtv: tableData[0].remarksRtv,
      reporter: pelapor,
      taxToNPWP: tableData[0].taxToNPWP,
      items: items,
      plant: tableData[0].plant,
    };
    callApi({ params, id });
  };

  const validateIsBm = () => {
    let isValid = true;
    for (let e of tableData) {
      if (e.customerCode !== e.customerCodeOld) {
        isValid = false;
        break;
      } else if (e.batch !== e.batchOld) {
        isValid = false;
        break;
      } else if (e.materialCode !== e.materialCodeOld) {
        isValid = false;
        break;
      } else if (e.netPrice !== e.netPriceOld) {
        isValid = false;
        break;
      } else if (cekQty === true) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    return isValid;
  };

  const validateIsChanges = () => {
    let isValid = true;
    for (let e of tableData) {
      const isPlantValid = e.plant && e.plant.startsWith("19");
      const isPlantCodeValid = e.plantCode && e.plantCode.startsWith("19");

      if (e.customerCode !== e.customerCodeOld) {
        isValid = false;
        break;
      } else if (e.materialCode !== e.materialCodeOld) {
        isValid = false;
        break;
      } else if (e.netPrice !== e.netPriceOld) {
        isValid = false;
        break;
      } else if (cekQty === true) {
        isValid = false;
        break;
      } else if (!isPlantValid || !isPlantCodeValid) {
        break;
      } else if (e.plant !== e.plantCode) {
        console.log("masuk");
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    return isValid;
  };

  const validateAddLine = () => {
    let isValid = true;
    for (let e of tableData) {
      if (e.addLine === "Y") {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    return isValid;
  };

  const res = Array.from(
    tableData.reduce(
      (m, { materialCode, qty }) =>
        m.set(materialCode, (m.get(materialCode) || 0) + parseInt(qty)),
      new Map()
    ),
    ([materialCode, qty]) => ({ materialCode, qty })
  );

  const res2 = Array.from(
    tableDataOld.reduce(
      (m, { materialCode, availableQty }) =>
        m.set(
          materialCode,
          (m.get(materialCode) || 0) + parseInt(availableQty)
        ),
      new Map()
    ),
    ([materialCode, qty]) => ({ materialCode, qty })
  );

  const validatePost = () => {
    let isValid = true;
    let i = 0;
    for (i; i < res.length; i++) {
      let total = res[i].qty;
      let qtyAwal = res2.map((d) => d.qty);

      console.log(total, qtyAwal[i]);
      if (total > qtyAwal[i]) {
        isValid = false;
        break;
      }
    }

    return isValid;
  };

  const handleSave = () => {
    const res = Array.from(
      tableData.reduce(
        (m, { materialCode, qty }) =>
          m.set(materialCode, (m.get(materialCode) || 0) + parseInt(qty)),
        new Map()
      ),
      ([materialCode, qty]) => ({ materialCode, qty })
    );

    const res2 = Array.from(
      tableDataOld.reduce(
        (m, { materialCode, availableQty }) =>
          m.set(
            materialCode,
            (m.get(materialCode) || 0) + parseInt(availableQty)
          ),
        new Map()
      ),
      ([materialCode, qty]) => ({ materialCode, qty })
    );

    const validatePost = () => {
      let isValid = true;
      let i = 0;
      for (i; i < res.length; i++) {
        let total = res[i].qty;
        let qtyAwal = res2.map((d) => d.qty);

        console.log(total, qtyAwal[i]);
        if (total > qtyAwal[i]) {
          isValid = false;
          break;
        }
      }

      return isValid;
    };
    if (cekQty === true) {
      if (!validatePost()) {
        return showErrorDialog(
          "Return Qty cannot > Total Available qty for the same item number"
        );
      }
    }

    //checking attachment

    const attachmentChecker = [];
    tableData.map((val, index) => {
      if (val.attachmentId) {
      } else {
        attachmentChecker.push(index);
      }
    });
    if (reason === undefined) {
      setBtnDisabled(false);
      return showErrorDialog("Please Select Reason !");
    }

    if (reason !== "132" && attachmentChecker.length > 0) {
      setBtnDisabled(false);
      return showErrorDialog("Please Upload Image !");
    }

    if (remark === "") {
      setBtnDisabled(false);
      return showErrorDialog("Please fill in the remark !");
    }

    // Setup Request Body Params
    tableData.map((value) => {
      if (reason === "132") {
        value.sloc = "B41";
      } else if (reason === "135") {
        value.sloc = "B42";
      }
      if (value.qty) {
      } else {
        value.qty = value.availableQty;
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });
    let isBm = "N";
    let addLine = "N";
    let isChanges = "N";
    if (!validateIsBm()) {
      isBm = "Y";
    }

    if (!validateAddLine()) {
      addLine = "Y";
    }

    if (!validateIsChanges()) {
      isChanges = "Y";
    }

    console.log(isBm, "isBm");
    const items = tableData.map((e) => {
      return {
        returnId: e.returnId,
        invoiceNo: e.invoiceNo,
        taxInvoiceNo: e.taxInvoiceNo,
        distributionChannel: e.distributionChannel,
        transactionDate: moment(e.transactionDate).format("YYYY-MM-DD"),
        po: e.po,
        dataSource: e.dataSource,
        crprgp: e.crprgp,
        // update
        attachmentId: e.attachmentId,
        batchOld: e.batchOld,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        expiredDate: e.expiredDate,
        materialCodeOld: e.materialCodeOld,
        materialCode: e.materialCode,
        materialNameOld: e.materialNameOld,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        netPriceOld: e.netPriceOld,
        nra: e.nra,
        availableQty: e.availableQty,
        qty: e.qty,
        returnUom: e.returnUom,
        sloc: e.sloc,
        uom: e.uom,
        remark: e.remarkRow,
        rayonType: e.rayonType,
        line: e.line,
        returnDetailId: e.returnDetailId,
        division: e.division,
        nonFraction: e.nonFraction,
        isBm: isBm,
        addLine: e.addLine,
        lineOld: e.lineOld,
      };
    });

    const id = tableData[0].returnId;
    const params = {
      // returnId: tableData[0].returnId,
      // invoiceNo: tableData[0].invoiceNo,
      // taxInvoiceNo: tableData[0].taxInvoiceNo,
      // customerCode: tableData[0].customerCode.toString(),
      // customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      // reasonCode: reason,
      // transactionDate: moment(tableData[0].transactionDate).format(
      //   "YYYY-MM-DD"
      // ),
      // plantCode: tableData[0].plantCode,
      // po: tableData[0].po,
      // dataSource: tableData[0].dataSource,
      // crprgp: tableData[0].crprgp,
      customerCodeOld: tableData[0].customerCodeOld.toString(),
      customerNameOld: tableData[0].customerNameOld,
      customerCode: tableData[0].customerCode.toString(),
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      plantCodeOld: tableData[0].plantCodeOld,
      plantNameOld: tableData[0].plantNameOld,
      plantCode: tableData[0].plantCode,
      reasonCode: reason,
      returnType: "MTKA",
      remark: remark,
      draft: false,
      rtvNo: tableData[0].rtvNo,
      rtvDate: tableData[0].rtvDate,
      rtvReceivingDate: tableData[0].rtvReceivingDate,
      remarksRtv: tableData[0].remarksRtv,
      reporter: pelapor,
      taxToNPWP: tableData[0].taxToNPWP,
      isBm: isBm,
      addLine: addLine,
      isChanges: isChanges,
      items: items,
      plant: tableData[0].plant,
    };
    console.log(params);
    console.log(tableData, "tableData");
    setBtnDisabled(true);
    callApi({ params, id });
  };

  const callApi = async ({ params, id }) => {
    try {
      const response = await dispatch(editRtv({ params, id }));
      if (response.payload.status === 200) {
        if (response.payload.data.data.length > 1) {
          const data = response.payload.data.data;
          const list = data.map((item) => item.retNumber);
          const action = await showSuccessDialog(
            "Data has been saved!",
            `Return have been Saved, your return number : <strong>${list}</strong>`
          );
          if (action.isConfirmed) history.push("/new-return/with-rtv");
          setBtnDisabled(false);
        } else {
          const action = await showSuccessDialog(
            "Data has been saved!",
            `Return have been Saved, your return number : <strong>${response.payload.data.data.retNumber}</strong>`
          );
          if (action.isConfirmed) history.push("/new-return/with-rtv");
          setBtnDisabled(false);
        }
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("error", error);
      setBtnDisabled(false);

      showErrorDialog(error.message);
    }
  };

  // const handleTest = async () => {
  //   try {
  //     let i = 0;
  //     for (i; tableData.length < 10; i++) {
  //       if
  //     }
  //   } catch (error) {}
  // };

  const StatusCrpFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent === "Y") {
      label = "Within CRP";
    } else if (cellContent === "N") {
      label = "Non CRP";
    } else if (cellContent === "N/A") {
      label = "N/A";
    }

    return <span>{label}</span>;
  };

  const handleCopy = (e, row, rowIndex, formatExtraData) => {
    setCekQty(true);
    const item = row;
    const newLine = parseInt(item.line) + 1;
    const _item = {
      ...item,
      uuid: uuidv4(),
      addLine: "Y",
      line: newLine.toString(),
      isClick: "Y",
    };
    const temp = [...formatExtraData];
    const indexTemp = { ...temp[rowIndex] };

    indexTemp.isClick = "N";
    temp[rowIndex] = indexTemp;
    const data = [...temp, _item];
    setTableData(data);
    forceUpdate();
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },

    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "invoice item number",
      dataField: "line",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
      style: { minWidth: "100px" },
    },
    {
      text: "Invoice Ref Date",
      dataField: "transactionDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Tax Invoice Ref Num",
      dataField: "taxInvoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "PO Ref",
      dataField: "taxInvoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      dataField: "EditMaterial",
      text: "Edit Material",
      editable: false,
      formatExtraData: tableData,
      formatter: (e, row, rowIndex, formatExtraData) => (
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit Materal</Tooltip>}
          >
            <div
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={() =>
                handleShowMaterial(e, row, rowIndex, formatExtraData)
              }
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </div>
          </OverlayTrigger>
        </div>
      ),
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },

    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    // {
    //   text: "Batch Old",
    //   dataField: "batchOld",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   editable: false,
    // },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      dataField: "EditBatch",
      text: "Edit Batch",
      editable: false,
      formatExtraData: tableData,
      formatter: (e, row, rowIndex, formatExtraData) => (
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit Batch</Tooltip>}
          >
            <div
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={() => handleShowBatch(e, row, rowIndex, formatExtraData)}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </div>
          </OverlayTrigger>
        </div>
      ),
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "FullBox",
      dataField: "nonFraction",
      formatter: StatusFormatter,
    },
    {
      text: "NetSales",
      dataField: "netPrice",
      editable: false,
      formatter: formatCurrency,
    },
    {
      dataField: "Edit NetSales",
      text: "Edit Price",
      editable: false,
      formatExtraData: tableData,
      formatter: (e, row, rowIndex, formatExtraData) => (
        <div>
          <OverlayTrigger
            overlay={
              <Tooltip id="products-edit-tooltip">Edit NetSales</Tooltip>
            }
          >
            <div
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={() => handleShowPrice(e, row, rowIndex, formatExtraData)}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </div>
          </OverlayTrigger>
        </div>
      ),
    },
    {
      text: "UOM",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: renderUom,
      formatExtraData: tableData,
      editable: false,
    },
    {
      text: "Avail Qty",
      dataField: "tempAvailableQty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },

    {
      text: "Return Qty",
      dataField: "qty",
      // editable: false,
      formatter: inputQtyFormmater,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      formatExtraData: tableData,
    },
    {
      text: "CRP/RGP",
      dataField: "crprgp",
      formatter: StatusCrpFormatter,
      align: "center",
      editable: false,
    },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      // hidden: reason === "132" ? true : false,
      formatter: (cell, row, rowIndex, formatExtraData) =>
        uploadFormatter(cell, row, rowIndex, formatExtraData),
      formatExtraData: {
        reason: reason,
        tableData: tableData,
      },
      editable: false,
    },
    {
      text: "Remarks",
      dataField: "remarkRow",
      formatter: remarkFormatter,
      formatExtraData: tableData,
      editable: false,
    },
    {
      dataField: "action",
      text: "add Batch",
      editable: false,
      formatExtraData: tableData,
      formatter: (e, row, rowIndex, formatExtraData) => (
        <div>
          {row.isClick === "Y" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Copy Item</Tooltip>}
            >
              <div
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={() => handleCopy(e, row, rowIndex, formatExtraData)}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Write.svg"
                    )}
                  />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      ),
    },
  ];

  // Modal Customer
  const [show, setShow] = useState(false);
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerOld, setCustomerOld] = useState({
    customerCode: "",
    customerName: "",
  });
  const [overlayCustomer, setOverlayCustomer] = useState(false);

  const handleClose = () => {
    setCustomerCode("");
    setCustomerName("");
    setShow(false);
    setTableDataCustomer([]);
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const [tableDataCustomer, setTableDataCustomer] = useState(dataCustomer);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = dataCustomer.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableDataCustomer(initData);
  }, [dataCustomer, pageSize, pageNo]);

  // Modal Batch
  const [showBatch, setShowBatch] = useState(false);
  const [materialCode, setMaterialCode] = useState("");
  const [batch, setBatch] = useState("");
  const [selectMaterial, setSelectMaterial] = useState([]);
  const [overlayBatch, setOverlayBatch] = useState(false);
  const [indexBatch, setIndexBatch] = useState("");

  const handleCloseBatch = () => {
    setMaterialCode("");
    setBatch("");
    setShowBatch(false);
    setTableDataCustomer([]);
    setOverlayBatch(false);
  };
  const handleShowBatch = (e, row, rowIndex, formatExtraData) => {
    setIndexBatch(rowIndex);
    setShowBatch(true);
    setMaterialCode(row.materialCode);
  };

  const [tableDataBatch, setTableDataBatch] = useState(dataBatch);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData =
      dataBatch === null
        ? []
        : dataBatch.map((item, index) => {
            return {
              ...item,
              no: index + 1 + pageBefore,
            };
          });
    setTableDataBatch(initData);
  }, [dataBatch, pageSize, pageNo]);

  const handleSearchBatch = async () => {
    setOverlayBatch(true);
    const params = {
      itemCode: materialCode,
      batch: batch,
      // plant: defaultPlant.toString(),
      pageNo: 1,
      pageSize: 100,
    };
    await dispatch(fetchBatch(params));
    setOverlayBatch(false);
  };

  const rowEventsBatch = {
    onClick: (e, row, rowIndex) => {
      if (row.expDate === "0001-01-01T00:00:00Z") {
        showErrorDialog("Please change batch because Expired Date null");
        console.log("test");
      } else {
        const action = showConfirmDialog(
          `Do you want change batch ${tableData[indexBatch].batch} To ${row.batch}`
        ).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            const temp = [...tableData];
            const indexTemp = { ...temp[indexBatch] };

            indexTemp.batch = row.batch;
            indexTemp.expiredDate = row.expDate;
            temp[indexBatch] = indexTemp;

            setTableData(temp);
            setMaterialCode("");
            setBatch("");
            setTableDataBatch([]);
            setShowBatch(false);
          }
        });
      }
    },
  };

  const columnsBatch = [
    { text: "No", dataField: "no" },
    { text: "Material Code", dataField: "itemCode" },
    { text: "batch", dataField: "batch" },
    { text: "expDate", dataField: "expDate", formatter: formatDate },
  ];

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = dataCustomer.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableDataCustomer(initData);
  }, [dataCustomer, pageSize, pageNo]);

  const handleSearchCustomer = async () => {
    setOverlayCustomer(true);
    const params = {
      customerCode: customerCode,
      customerName: customerName,
      taxToNPWP: tableData[0].taxToNPWP,
      pageNo: 1,
      pageSize: 100,
    };
    await dispatch(fetchCustomer(params));
    setOverlayCustomer(false);
  };

  const rowEventsCustomer = {
    onClick: (e, row, rowIndex, cell) => {
      if (row.customerBlocked === true) {
        showDialog(row.blockRemark);
      } else {
        const action = showConfirmDialog(
          `Do you want change customer ${tableData[0].customerCodeOld} "${tableData[0].customerNameOld}", Plant "${tableData[0].plantCodeOld}" To Customer ${row.customerCode} "${row.customerName} Plant ${row.plantCode}"`
        ).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            setCustomerCode("");
            setCustomerName("");
            setShow(false);
            setTableDataCustomer([]);
            setShow(false);
            const initData = tableData.map((item, index) => ({
              ...item,
              customerCode: row.customerCode.toString(),
              customerName: row.customerName.toString(),
              plantCode: row.plantCode,
              plantName: row.plantName,
            }));
            setTableData(initData);
          }
        });
      }
    },
  };

  const columnsCustomer = [
    { text: "No", dataField: "no" },
    { text: "Customer Code", dataField: "customerCode" },
    { text: "Customer Name", dataField: "customerName" },
    { text: "distribution Channel", dataField: "distChannel" },
    // { text: "Address", dataField: "street1" },
    { text: "City", dataField: "city" },
    { text: "Sales Office", dataField: "salesOffice" },
    { text: "Plant Code", dataField: "plantCode" },
    { text: "Plant Name", dataField: "plantName" },
  ];

  //handle change material

  const [showMaterial, setShowMaterial] = useState(false);
  const [materialOld, setMaterialOld] = useState("");
  const [materialNew, setMaterialNew] = useState("");
  const [selectMaterialNew, setSelectMaterialNew] = useState([]);
  const [indexMaterial, setIndexMaterial] = useState("");
  const [overlayMaterial, setOverlayMaterial] = useState(false);

  const handleCloseMaterial = () => {
    setMaterialCode("");
    setShowMaterial(false);
    setTableDataMaterial([]);
  };
  const handleShowMaterial = (e, row, rowIndex, formatExtraData) => {
    setIndexMaterial(rowIndex);
    setShowMaterial(true);
    setMaterialOld(row.materialCode);
  };

  const [tableDataMaterial, setTableDataMaterial] = useState(dataMaterial);

  useEffect(() => {
    // Add number
    const initData = dataMaterial.map((item, index) => {
      return {
        ...item,
        no: index + 1,
      };
    });
    setTableDataMaterial(initData);
  }, [dataMaterial]);

  const handleSearchMaterial = async () => {
    setOverlayBatch(true);
    const params = {
      oldMaterialCode: materialOld,
      pageNo: 1,
      pageSize: 100,
    };
    await dispatch(fetchMaterialOld(params));
    setOverlayBatch(false);
  };

  const rowEventsMaterial = {
    onClick: (e, row, rowIndex) => {
      const action = showConfirmDialog(
        `Do you want change Material ${tableData[indexMaterial].materialCode} To ${row.materialCode}`
      ).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const temp = [...tableData];
          const indexTemp = { ...temp[indexMaterial] };

          indexTemp.materialCode = row.materialCode;
          temp[indexMaterial] = indexTemp;

          setTableData(temp);
          setMaterialCode("");
          setBatch("");
          setTableDataMaterial([]);
          setShowMaterial(false);
        }
      });
    },
  };

  const columnsMaterial = [
    { text: "No", dataField: "no" },
    { text: "Material Code", dataField: "materialCode" },
    { text: "material Description", dataField: "materialDescription" },
  ];

  // Modal NetPrice
  const [showPrice, setShowPrice] = useState(false);
  const [indexPrice, setIndexPrice] = useState("");
  const [changePrice, setChangePrice] = useState("");
  const [netSales, setNetSales] = useState("");

  const handleClosePrice = () => {
    setShowPrice(false);
  };
  const handleShowPrice = (e, row, rowIndex, formatExtraData) => {
    setNetSales(row.netPriceOld);
    setIndexPrice(rowIndex);
    setShowPrice(true);
  };

  const handleChangePrice = () => {
    const action = showConfirmDialog(
      `Do you want change Net Sales ${tableData[indexPrice].netPriceOld} To ${changePrice}`
    ).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const temp = [...tableData];
        const indexTemp = { ...temp[indexPrice] };

        indexTemp.netPrice = changePrice;
        temp[indexPrice] = indexTemp;

        setTableData(temp);
        setChangePrice("");
        setShowPrice(false);
      }
    });
  };

  return tableData.length > 0 ? (
    loading ? (
      <LayoutSplashScreen />
    ) : (
      <>
        <Card>
          <CardHeader title="With RTV Detail">
            <CardHeaderToolbar>
              <Button variant="primary" className="mr-5" onClick={handleShow}>
                Change Customer
              </Button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>RTV Number </b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].rtvNo}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>RTV Date </b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].rtvDate}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>RTV Receiving Date </b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].rtvReceivingDate}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Plant Name</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].plantNameOld}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Reporter</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        value={pelapor}
                        onChange={(e) => setPelapor(e.target.value)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  {tableData[0].customerCodeOld !==
                    tableData[0].customerCode && (
                    <>
                      <Form.Group as={Row}>
                        <Form.Label column sm={4}>
                          <b>Customer Code Old</b>
                        </Form.Label>
                        <Col sm={5}>
                          <Form.Control
                            type="text"
                            placeholder="Customer Code"
                            disabled
                            value={tableData[0].customerCodeOld}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={4}>
                          <b>Customer Name Old</b>
                        </Form.Label>
                        <Col sm={5}>
                          <Form.Control
                            type="text"
                            placeholder="Customer Name"
                            disabled
                            value={tableData[0].customerNameOld}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={4}>
                          <b>Plant Name Old</b>
                        </Form.Label>
                        <Col sm={5}>
                          <Form.Control
                            type="text"
                            placeholder="Customer Name"
                            disabled
                            value={tableData[0].plantNameOld}
                          />
                        </Col>
                      </Form.Group>
                    </>
                  )}
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Name</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].customerName}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].customerCode}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Reason </b>
                    </Form.Label>
                    <Col sm={5}>
                      <Select
                        options={reasonOptions}
                        value={getValueReason(reason, reasonOptions)}
                        placeholder="Select Reason..."
                        onChange={handleReasonChange}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Remark</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        as="textarea"
                        // onChange={handleRemarkChange}
                        onChange={(e) => {
                          setRemark(e.target.value);
                        }}
                        placeholder="Leave a comment here"
                        maxLength={35}
                        style={{ height: "100px" }}
                        value={remark}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              {/* Table Material*/}
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="uuid"
                data={tableData}
                columns={columns}
                pagination={paginationFactory()}
                hover
                cellEdit={cellEditFactory({
                  mode: "click",
                  blurToSave: true,
                })}
              />
            </Form>

            <Form>
              <Row>
                <Col md="6" sm="6" lg="8">
                  <Button
                    variant="primary"
                    className="mr-5"
                    disabled={btnDisabled}
                    onClick={handleDraft}
                  >
                    Draft
                  </Button>
                  <Button
                    variant="success"
                    className="mr-5"
                    disabled={btnDisabled}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  <Button
                    variant="secondary"
                    className="mr-5"
                    onClick={() => history.push("/new-return/with-rtv")}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        {/* customer */}

        <Modal show={show} onHide={handleClose} size="lg">
          <LoadingFetchData active={overlayCustomer} />
          <Modal.Header closeButton>
            <Modal.Title>Customer Search</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setCustomerCode(e.target.value);
                        }}
                        value={customerCode}
                        required
                        type="number"
                        placeholder="Costumer Code"
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setCustomerName(e.target.value);
                        }}
                        value={customerName}
                        required
                        type="text"
                        placeholder="Costumer Name"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Button
                className="mb-5"
                variant="secondary"
                onClick={handleSearchCustomer}
              >
                Search
              </Button>
            </Form>
            {dataCustomer.length > 0 && (
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="customerId"
                data={tableDataCustomer}
                columns={columnsCustomer}
                pagination={paginationFactory()}
                // onTableChange={handleTableChangeCustomer}
                rowEvents={rowEventsCustomer}
                hover
              />
            )}
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* batch */}
        <Modal show={showBatch} onHide={handleCloseBatch} size="lg">
          <LoadingFetchData active={overlayBatch} />
          <Modal.Header closeButton>
            <Modal.Title>Batch Search</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Material Code</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setMaterialCode(e.target.value);
                        }}
                        value={materialCode}
                        required
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Batch</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setBatch(e.target.value);
                        }}
                        value={batch}
                        required
                        type="text"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Button
                className="mb-5"
                variant="secondary"
                onClick={handleSearchBatch}
              >
                Search
              </Button>
            </Form>
            {dataBatch && dataBatch.length > 0 && (
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="batchId"
                data={tableDataBatch}
                columns={columnsBatch}
                pagination={paginationFactory()}
                // onTableChange={handleTableChangeCustomer}
                rowEvents={rowEventsBatch}
                hover
              />
            )}
          </Modal.Body>
        </Modal>

        {/* Material */}
        <Modal show={showMaterial} onHide={handleCloseMaterial} size="lg">
          <LoadingFetchData active={overlayBatch} />
          <Modal.Header closeButton>
            <Modal.Title>Material Search</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Material Old</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setMaterialOld(e.target.value);
                        }}
                        value={materialOld}
                        required
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Material New</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setMaterialNew(e.target.value);
                        }}
                        value={materialNew}
                        required
                        type="text"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Button
                className="mb-5"
                variant="secondary"
                onClick={handleSearchMaterial}
              >
                Search
              </Button>
            </Form>
            {dataMaterial.length > 0 && (
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="batchId"
                data={tableDataMaterial}
                columns={columnsMaterial}
                pagination={paginationFactory()}
                // onTableChange={handleTableChangeCustomer}
                rowEvents={rowEventsMaterial}
                hover
              />
            )}
          </Modal.Body>
        </Modal>

        {/* Material */}
        <Modal show={showPrice} onHide={handleClosePrice} size="lg">
          <LoadingFetchData active={overlayBatch} />
          <Modal.Header closeButton>
            <Modal.Title>NetSales Change</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>NetSales Old</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control value={netSales} disabled />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>NetSales New</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setChangePrice(e.target.value);
                        }}
                        value={changePrice}
                        required
                        type="text"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleClosePrice}>
                  Close
                </Button>
                <Button variant="primary" onClick={handleChangePrice}>
                  Changes
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
      </>
    )
  ) : null;
};
